export const Index_Route = "/";
export const Base_Url_Route = Index_Route + "home/";

// ورود
export const Login_Route = Base_Url_Route + "login";
export const ResetPassword_Route = Base_Url_Route + "reset-password";

export const MP_Loading_Route = Base_Url_Route + "loading-page";
export const MP_Error_Route = Base_Url_Route + "error";
export const MP_SplashScreen_Route = Base_Url_Route + "splash-screen";

//پروفایل کاربری
export const MP_Profile_Route = Base_Url_Route + "profile";
// تکمیل اطلاعات
export const MP_CompleteRegister_Route = Base_Url_Route + "completeRegister";
// پیام ها
export const MP_Message_Route = Base_Url_Route + "messages/";
// جزئیات پیام
export const MP_MessageDetial_Route = MP_Message_Route + ":id";

//ShortUrlForPassengerTrip
export const MP_CheckTripAccess_Route = Base_Url_Route + "p/cta/:id";
export const MP_PassengerReservedSales_Route = Base_Url_Route + "p/rs";

// امنیت سفر
export const MP_TripSecurity_Route = Base_Url_Route + "trip-security/:id";

//کیف پول
export const MP_Wallet_Route = Base_Url_Route + "wallet/";
export const MP_WalletTransactions_Route = MP_Wallet_Route + "transactions";
export const MP_AddCredit_Route = MP_Wallet_Route + "addcredit";
export const MP_WalletReceipt_Route = MP_Wallet_Route + "receipt";

// درگاه پرداخت
export const MP_PaymentPort_Route = "transportpayments/redirecttoipg?orderid=";

// پنل پیمانکار
export const TransportationCompany_Route = "/panel/company/:companyId";
// پنل واحد
export const TransportationUnit_Route = "/panel/business/:businessId";
// پنل سازمانی
export const Organization_Route =
  "/panel/organization/:organizationId/dashboard";
// راننده
export const Driver_Route = "/driver/";
// کیوسک

export const Kiosk_Route = "/kiosk/:id";
// دلیوری

export const Courier_Route = "/courier/";
// پنل دلیوری
export const Delivery_Panel_Route = "/delivery-panel/:businessId";
